// extracted by mini-css-extract-plugin
export default {"header":"Header_header__7wKYx","header__logo":"Header_header__logo__ZiVkX","navigation":"Header_navigation__5sBJM","link":"Header_link__hg4yI"};